




















































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as messages from "@/services/messages";
import { User } from "@/types/Users";

@Component
export default class NewConversationDialog extends Vue {
  isValid = false;
  loading = false;
  selectedUsers = [];

  @Prop({ default: false }) opened!: boolean;

  @Watch("opened")
  onOpened(opened: boolean) {
    if (opened) (this.$refs.form as HTMLFormElement).reset();
  }

  async mounted() {
    await messages.loadContacts(this.$store);
  }

  get contacts() {
    return this.$store.state.messages.contacts.filter((user: User) => {
      return user.id !== this.me?.id;
    });
  }

  get me() {
    return this.$store.getters.me;
  }

  closeDialog() {
    this.$emit("update:opened", false);
  }

  async createConversation() {
    this.loading = true;
    try {
      const conversation = await messages.createConversation(
        this.$store,
        this.selectedUsers
      );
      this.$router.push({
        name: "conversation",
        params: { conversationId: conversation.id },
      });
      this.closeDialog();
    } finally {
      this.loading = false;
    }
  }
}
